<app-popup-layout #modal>
  <div class="container m-0 p-0">
    <div class="row m-0 p-0">
      <div class="col-sm-12 m-0 p-0 d-flex flex-col">
        <header class="modal-header">
          <p class="modal-title">Help</p>
          <app-close-button class="ms-auto" style="align-self: center"
          (onCloseEmitter)="modal.close()"></app-close-button>
        </header>

        <section class="modal-section">
          <p>The eRUPI voucher is a digital, contactless prepaid voucher designed to streamline payments and ensure
            funds
            are used for their intended purpose. It enables secure, hassle-free transactions. Accepted at various
            service
            centers and retail outlets, eRUPI is an efficient solution for managing petty cash and company expenses,
            providing enhanced financial control and ease of use for businesses.
          </p>

        </section>
      </div>

      <div class="col-sm-12 col-md-12">
        <div class="horozontal-tab-shell">
          <!-- Tabs -->
          <ul class="d-flex expense-tab-container">
            <li [class.active]="activePanel === 'activate_voucher'"
              (click)="employeeManagementPanel('activate_voucher')">
              How To Activate Vouchers
            </li>

            <li [class.active]="activePanel === 'redeem_voucher'" id="expense-dashboard-employee_advance-tab"
              (click)="employeeManagementPanel('redeem_voucher')">
              How To Redeem Vouchers
            </li>
          </ul>

          <div class="horozontal-tab-container">
            @if (activePanel === 'activate_voucher') {
              <div>
              <img src="/assets/svg/activate-voucher-erupi.png" alt="anouncing msg" class="img-banner" style="width: 100%;
    height: auto;" />
              </div>
            }

            @if (activePanel === 'redeem_voucher') {
              <div>
              <img src="/assets/svg/redeem-voucher-erupi.png" alt="anouncing msg" class="img-banner" style="width: 100%;
    height: auto;" />
              </div>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</app-popup-layout>